import React from 'react'
import SellYourMusicFirstSection from './SellYourMusicFirstSection'
import SellYourMusicSecondSection from './SellYourMusicSecondSection'
import SellYourMusicThirdSection from './SellYourMusicThirdSection'
import SellYourMusicFourthSection from './SellYourMusicFourthSection'

function SellYourMusic() {
    return (
        <div>
            <SellYourMusicFirstSection />
            <SellYourMusicSecondSection />
            <SellYourMusicThirdSection />
            <SellYourMusicFourthSection />
        </div>
    )
}

export default SellYourMusic
